import { Snackbar, Alert, SnackbarOrigin } from '@mui/material';
import { snackBarSX } from '@/components/content/Notifications/styles/snackbar';
import { alertSX } from '@/components/content/Notifications/styles/alert';
import { NotificationText } from '@/data/context/notifications';

interface SnackbarAlertProps {
	id: string;
	message?: NotificationText;
	anchorOrigin?: SnackbarOrigin;
	severity?: 'error' | 'success' | 'info' | 'warning';
	onClear: () => void;
}

export const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
	id,
	message,
	anchorOrigin,
	severity,
	onClear,
}) => (
	<Snackbar
		id={id}
		open={message ? true : false}
		anchorOrigin={anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
		autoHideDuration={5000}
		onClose={onClear}
		ClickAwayListenerProps={{
			onClickAway: onClear,
			mouseEvent: 'onMouseDown',
		}}
		sx={snackBarSX}
	>
		<Alert severity={severity} onClose={onClear} sx={alertSX} icon={false}>
			{message}
		</Alert>
	</Snackbar>
);
